import { createSlice } from '@reduxjs/toolkit';

import { stopTestAction } from '../thunk/stopTest';

const stopTestSlice = createSlice({
  name: 'stopTest',
  initialState: {
    data: {},
    error: null,
    loading: false,
  },
  extraReducers: (builder) => {
    builder
      .addCase(stopTestAction.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(stopTestAction.fulfilled, (state, action) => {
        state.data = action.payload;
        state.loading = false;
        state.error = null;
      })
      .addCase(stopTestAction.rejected, (state, action) => {
        state.error = action.payload || action.error?.message;
        state.loading = false;
      });
  },
});

export default stopTestSlice.reducer;
